import type { PlatformUser } from "@/context/PlatformAuthContext";

export function isPlaceholderUserName(name: string | null | undefined): boolean {
  if (name == null || typeof name !== 'string') return true;
  const t = name.trim();
  if (!t) return true;
  return /^user\s*#?\d+$/i.test(t);
}

export function getUserDisplayName(user: PlatformUser | null): string {
  if (!user) return '';
  const raw = user.name?.trim();
  if (raw && !isPlaceholderUserName(raw)) return raw;
  if (user.email?.trim()) return user.email.trim();
  return '';
}

export function getUserGreetingName(user: PlatformUser | null): string {
  if (!user) return '';
  const rawName = user.name?.trim();
  if (rawName && !isPlaceholderUserName(rawName)) {
    return rawName.split(/\s+/).filter(Boolean)[0] || rawName;
  }
  const em = user.email?.trim();
  if (em) return em.split('@')[0] || em;
  return '';
}
